<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">家充无忧服务订单列表</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <!--
        <button class="common-bg-button" @click="toShowUserValidFun()">
          用户验证：{{ onOffFlagName }}
        </button>
        -->
        <button
          class="common-bg-button"
          @click="setServiceFree()"
        >
          服务费状态切换
        </button>
        <button
          class="common-bg-button"
          @click="toUpdatePileStatusFun()"
        >
          激活切换
        </button>
        <button
          class="common-bg-button"
          @click="toEditOrder()"
        >
          活动订单编辑
        </button>
        <button
          class="common-bg-button"
          @click="
            () => {
              showMultiQuery = !showMultiQuery;
            }
          "
        >
          高级筛选
        </button>
        <button
          class="common-bg-button"
          @click="toExportList()"
        >
          导 出
        </button>
      </div>
      <!-- 高级筛选 -->
      <div
        class="multi-query-div el-fade-in-linear"
        v-if="showMultiQuery"
      >
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input
                clearable
                v-model="queryInfo.searchKey"
                size="small"
                placeholder="请输入订单编号/用户手机号/用户姓名"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单状态</p>
              <el-select
                v-model="queryInfo.statusList"
                size="small"
                clearable
                multiple
                @change="orderStatusChange"
                class="full-width"
                placeholder="请选择订单状态"
              >
                <el-option
                  v-for="a in orderStatusList"
                  :key="a.code"
                  :label="a.title"
                  :value="a.code"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩使用状态</p>
              <el-select
                v-model="queryInfo.activateStatus"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择充电桩使用状态"
              >
                <el-option
                  v-for="a in activeStatusList"
                  :key="a.code"
                  :label="a.title"
                  :value="a.code"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单创建时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.createFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.createToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">购买名称</p>
              <el-select
                v-model="queryInfo.cableInstallMeterType"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择购买名称"
              >
                <el-option
                  label="家充无忧服务"
                  value=""
                />
                <el-option
                  label="家充无忧服务0米"
                  value="0"
                />
                <el-option
                  label="家充无忧服务10米"
                  value="10"
                />
                <el-option
                  label="家充无忧服务20米"
                  value="20"
                />
                <el-option
                  label="家充无忧服务30米"
                  value="30"
                />
                <el-option
                  label="家充无忧服务40米"
                  value="40"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">安装状态</p>
              <el-select
                v-model="queryInfo.activityOrderInstallStatusList"
                size="small"
                clearable
                multiple
                class="full-width"
                placeholder="请选择安装状态"
              >
                <el-option
                  label="未勘察未安装"
                  value="INVESTIGATION_INSTALL_INIT"
                />
                <el-option
                  label="已勘察已安装"
                  value="INVESTIGATION_INSTALL_FINISHED"
                />
                <el-option
                  label="已勘察不安装"
                  value="INVESTIGATION_FINISHED_NOT_INSTALL"
                />
                <el-option
                  label="未勘察不安装"
                  value="INVESTIGATION_INIT_NOT_INSTALL"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">拆桩完成时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.pileOrderCancelCompleteFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.pileOrderCancelCompleteToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">客户联系状态</p>
              <el-select
                v-model="queryInfo.activityOrderContractStatusList"
                size="small"
                clearable
                multiple
                class="full-width"
                placeholder="请选择客户联系状态"
              >
                <el-option
                  label="待联系"
                  value="WAIT_CONTRACT"
                />
                <el-option
                  label="已联系"
                  value="CONTRACTED"
                />
                <el-option
                  label="未联系上"
                  value="NOT_CONTRACT"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">解约完成时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.activityCancelCompletedFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.activityCancelCompletedToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩绑定激活时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.periodStartFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.periodStartToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩到期时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.periodEndFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.periodEndToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">充电桩安装完成时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.pileInstallCompletedFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.pileInstallCompletedToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">待签约短信下发时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.signMessageSendFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.signMessageSendToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">报名渠道</p>
              <div class="flex-r">
                <el-select
                  v-model="queryInfo.channel"
                  size="small"
                  clearable
                  class="full-width"
                  placeholder="请选择报名渠道"
                >
                  <el-option
                    label="微信"
                    :value="0"
                  />
                  <el-option
                    label="支付宝(私域)"
                    :value="1"
                  />
                  <el-option
                    label="小红书"
                    :value="2"
                  />
                  <el-option
                    label="抖音"
                    :value="3"
                  />
                  <el-option
                    label="支付宝公充"
                    :value="4"
                  />
                  <el-option
                    label="家充位置"
                    :value="5"
                  />
                  <el-option
                    label="APP点击"
                    :value="6"
                  />
                  <el-option
                    label="桩到家微信小程序"
                    :value="7"
                  />
                  <el-option
                    label="桩到家支付宝小程序"
                    :value="8"
                  />
                  <el-option
                    label="桩到家"
                    :value="9"
                  />
                  <el-option
                    label="桩到家PC官网"
                    :value="10"
                  />
                  <el-option
                    label="桩到家微信服务号"
                    :value="11"
                  />
                  <el-option
                    label="桩到家微信服务号菜单"
                    :value="12"
                  />
                  <el-option
                    label="微信朋友圈"
                    :value="13"
                  />
                </el-select>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">不签约/不安装原因</p>
              <el-select
                v-model="queryInfo.installFailReasonList"
                size="small"
                clearable
                class="full-width"
                multiple
                placeholder="请选择不安装原因"
              >
                <el-option
                  label="报装困难"
                  value="报装困难"
                />
                <el-option
                  label="电源点问题"
                  value="电源点问题"
                />
                <el-option
                  label="无固定车位"
                  value="无固定车位"
                />
                <el-option
                  label="报装未完成"
                  value="报装未完成"
                />
                <el-option
                  label="无安装条件内"
                  value="无安装条件内"
                />
                <el-option
                  label="增项费用高"
                  value="增项费用高"
                />
                <el-option
                  label="活动复杂不易懂"
                  value="活动复杂不易懂"
                />
                <el-option
                  label="暂时没有充电桩需求"
                  value="暂时没有充电桩需求"
                />
                <el-option
                  label="随便点点"
                  value="随便点点"
                />
                <el-option
                  label="不认可用户协议"
                  value="不认可用户协议"
                />
                <el-option
                  label="不认可免押协议"
                  value="不认可免押协议"
                />
                <el-option
                  label="物业问题"
                  value="物业问题"
                />
                <el-option
                  label="不划算"
                  value="不划算"
                />
                <el-option
                  label="未操作过报名"
                  value="未操作过报名"
                />
                <el-option
                  label="产品与需求不符"
                  value="产品与需求不符"
                />
                <el-option
                  label="其他"
                  value="其他"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">芝麻免押状态</p>
              <el-select
                v-model="queryInfo.zmSignStatus"
                size="small"
                clearable
                multiple
                class="full-width"
                placeholder="请选择芝麻免押状态"
              >
                <el-option
                  label="已签约"
                  value="Y"
                />
                <el-option
                  label="已解约"
                  value="N"
                />
                 <el-option
                  label="未签约"
                  value=""
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">商家代扣状态</p>
              <el-select
                v-model="queryInfo.holdSignStatus"
                size="small"
                clearable
                multiple
                class="full-width"
                placeholder="请选择商家代扣状态"
              >
                <el-option
                  label="已签约"
                  value="Y"
                />
                <el-option
                  label="已解约"
                  value="N"
                />
                <el-option
                  label="未签约"
                  value=""
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">是否下发签约短信</p>
              <el-select
                v-model="queryInfo.signFlag"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择是否下发签约短信"
              >
                 <el-option
                  label="未签约"
                  value="N"
                />
                <el-option
                  label="已签约"
                  value="Y"
                />
             
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">签约完成时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.signFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.signToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">签约状态更新时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.signedUpdateFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.signedUpdateToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                  class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">已签约预警状态</p>
              <el-select
                v-model="queryInfo.signedWarningStatusList"
                size="small"
                clearable
                multiple
                class="full-width"
                placeholder="请选择已签约预警状态"
              >
                <el-option
                  label="正常"
                  value="正常"
                />
                <el-option
                  label="D3预警"
                  value="D3预警"
                />
                <el-option
                  label="D4预警"
                  value="D4预警"
                />
                <el-option
                  label="D5预警"
                  value="D5预警"
                />
                <el-option
                  label="D6预警"
                  value="D6预警"
                />
                <el-option
                  label="D7预警"
                  value="D7预警"
                />
                <el-option
                  label="D7+预警"
                  value="D7+预警"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">是否有固定车位</p>
              <el-select
                v-model="queryInfo.parkSpace"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择是否有固定车位"
              >
                <el-option
                  label="是"
                  value="Y"
                />
                <el-option
                  label="否"
                  value="N"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">是否可提供联网环境</p>
              <el-select
                v-model="queryInfo.networkEnvironment"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择是否可提供联网环境"
              >
                <el-option
                  label="是"
                  value="Y"
                />
                <el-option
                  label="否"
                  value="N"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">是否获取过折扣券</p>
              <el-select
                  v-model="queryInfo.haveCoupon"
                  size="small"
                  clearable
                  class="full-width"
                  placeholder="请选择是否获取过折扣券"
              >
                <el-option label="是" value="Y" />
                <el-option label="否" value="N" />
              </el-select>
            </el-col>
          </el-row>
        </div>

        <div class="query-flex-btns-div margin-bottom-16">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button
            class="common-bg-button"
            @click="resetQuery()"
          >
            重 置
          </button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          @selection-change="
            (sels) => {
              selections = sels;
            }
          "
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
          />
          <el-table-column
            prop="pileInstallOrderNo"
            label="订单编号"
            width="240"
            align="center"
            fixed="left"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="goDetailByOne(scope.row)"
              >
                {{ scope.row.activityOrder.activityOrderNo }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="用户姓名"
            width="140"
            align="center"
            fixed="left"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.name
            }}</template>
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="用户手机号"
            width="160"
            align="center"
            fixed="left"
            :key="Math.random()"
          >
            <div
              slot="header"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <span style="margin-right: 8px">用户手机号</span>
              <img
                style="width: 20px; height: 20px"
                src="../../../assets/app-card-style/眼睛_隐藏.png"
                alt=""
                v-if="!isFlag"
                @click="flagChange('1')"
              />
              <img
                style="width: 20px; height: 20px"
                src="../../../assets/app-card-style/眼睛_显示.png"
                alt=""
                v-if="isFlag"
                @click="flagChange('1')"
              />
            </div>
            <template slot-scope="scope">
              <span v-if="isFlag">{{ scope.row.activityOrder.mobile }}</span>
              <span v-else>{{
                scope.row.activityOrder.mobile
                  ? scope.row.activityOrder.mobile.replace(
                      scope.row.activityOrder.mobile.substring(2, 9),
                      "*******"
                    )
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="orderName"
            label="购买名称"
            width="200"
            align="center"
          >
            <template slot-scope="scope"
              >家充无忧服务{{ scope.row.cableInstallMeterType
              }}<span v-if="scope.row.cableInstallMeterType != ''"
                >米</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="zeroPayConfigurationId"
            label="关联服务套餐配置ID"
            width="260"
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="goDetailByOnes(scope.row)"
              >
                {{ scope.row.zeroPayConfigurationId }}</el-link
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="servicePrice"
            label="充电服务费(元)"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.activityOrderCustomPrice.servicePrice == null"
                >{{ "--" }}</span
              >
              <span>{{ scope.row.activityOrderCustomPrice.servicePrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="priceActiveStatus"
            label="服务费状态"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                type="success"
                v-if="
                  scope.row.activityOrderCustomPrice.priceActiveStatus ===
                  'ACTIVE'
                "
                >启用</el-tag
              >
              <el-tag
                type="danger"
                v-else
                >停用</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="channel"
            label="报名渠道"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.channel === 0">微信</span>
              <span v-if="scope.row.channel === 1">支付宝私域</span>
              <span v-if="scope.row.channel === 2">小红书</span>
              <span v-if="scope.row.channel === 3">抖音</span>
              <span v-if="scope.row.channel === 4">支付宝公域车生活公充</span>
              <span v-if="scope.row.channel === 5">支付宝公域车生活家充</span>
              <span v-if="scope.row.channel === 6">APP</span>
              <span v-if="scope.row.channel === 7">桩到家微信小程序</span>
              <span v-if="scope.row.channel === 8">桩到家支付宝小程序</span>
              <span v-if="scope.row.channel === 9">桩到家APP</span>
              <span v-if="scope.row.channel === 10">桩到家PC官网</span>
              <span v-if="scope.row.channel === 11">桩到家微信服务号</span>
              <span v-if="scope.row.channel === 12">桩到家微信服务号菜单</span>
              <span v-if="scope.row.channel === 13">微信朋友圈</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="订单备注"
            width="320"
            align="center"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="320"
                trigger="hover"
              >
                <div>{{ scope.row.activityOrder.remark }}</div>
                <span
                  slot="reference"
                  v-if="scope.row.activityOrder.remark.length > 20"
                  >{{
                    scope.row.activityOrder.remark.substr(0, 20) + "..."
                  }}</span
                >
                <span
                  slot="reference"
                  v-else
                  >{{ scope.row.activityOrder.remark }}</span
                >
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="orderStatusName"
            label="订单状态"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="color: #2871ff"
                v-if="scope.row.orderStatus === '01'"
                >已支付</span
              >
              <span
                style="color: #0bbab4"
                v-if="scope.row.orderStatus === '02'"
                >使用中</span
              >
              <span
                style="color: #ff2828"
                v-if="scope.row.orderStatus === '03'"
                >已退款</span
              >
              <span
                style="color: #8d8d8d"
                v-if="scope.row.orderStatus === '04'"
                >已到期</span
              >
              <span
                style="color: #49afe7"
                v-if="scope.row.orderStatus === '05'"
                >已报名</span
              >
            </template>
          </el-table-column> -->
          <el-table-column
            prop="activityOrderStatusName"
            label="订单状态"
            width="140"
            align="center"
          />
          <el-table-column
            prop="signFlag"
            label="是否下发签约短信"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.signFlag === 'Y'">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="signMessageSendTime"
            label="待签约短信下发时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="sesameStatus"
            label="芝麻免押状态"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sesameStatus === 'Y'">已签约</span>
              <span v-else-if="scope.row.sesameStatus === 'N'">已解约</span>
              <span v-else>未签约</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="holdAgreement"
            label="商家代扣状态"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.holdAgreement === 'Y'">已签约</span>
              <span v-else-if="scope.row.holdAgreement === 'N'">已解约</span>
              <span v-else>未签约</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="activityOrderContractStatusName"
            label="客服联系状态"
            width="200"
            align="center"
          />
          <el-table-column
            prop="activityOrderInstallStatusName"
            label="安装状态"
            width="200"
            align="center"
          />
          <el-table-column
            prop="installFailReason"
            label="不签约/不安装原因"
            width="200"
            align="center"
          />
          <el-table-column
            prop="pileCode"
            label="IMEI"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{ scope.row.pileCode }}</template>
          </el-table-column>
          <el-table-column
            prop="pileCode"
            label="充电桩资产编号"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.pileCode ? "ZDZC" + scope.row.pileCode : ""
            }}</template>
          </el-table-column>

          <el-table-column
            prop="createdWhen"
            label="报名创建时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="pileInstallOrderNo"
            label="关联主服订单号"
            width="260"
            align="center"
          />
          <el-table-column
            prop="pileInstallCompletedTime"
            label="充电桩安装完成时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="vehicleModel"
            label="充电桩使用状态"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.activateStatusName
            }}</template>
          </el-table-column>
          <el-table-column
            prop="bindTime"
            label="充电桩绑定激活时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.bindTime
            }}</template>
          </el-table-column>
          <el-table-column
            prop="activateOperatePer"
            label="激活切换操作人"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityActivateRecord.createdByName
            }}</template>
          </el-table-column>
          <el-table-column
            prop="activateOperateWhen"
            label="激活切换操作时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityActivateRecord.createdWhen
            }}</template>
          </el-table-column>
          <el-table-column
            prop="periodEndTime"
            label="充电桩到期时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.periodEndTime
            }}</template>
          </el-table-column>
          <el-table-column
            prop="periodEndTime"
            label="充电桩最近充电时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.lastChargeTime
            }}</template>
          </el-table-column>
          <el-table-column
            prop="activityAlipayOverdueTime"
            label="账单逾期时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="activityDefaultedTime"
            label="活动违约时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="activityCancelApplicationTime"
            label="解约申请时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="activityCancelCompletedTime"
            label="解约完成时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="priceStartDateTime"
            label="服务费生效时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrderCustomPrice.activationStartDatetime
            }}</template>
          </el-table-column>
          <el-table-column
            prop="priceEndDateTime"
            label="服务费截止时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrderCustomPrice.activationEndDatetime
            }}</template>
          </el-table-column>
          <el-table-column
            prop="pileCancelOrderNo"
            label="关联主服拆桩订单编号"
            width="240"
            align="center"
          />
          <el-table-column
            prop="pileOrderCancelCompleteTime"
            label="拆桩完成时间"
            width="200"
            align="center"
          />
          <el-table-column
            prop="totalChargeOrder"
            label="累计充电订单数"
            width="200"
            align="center"
          />
          <el-table-column
            prop="totalChargeElectricity"
            label="累计充电电量(kwh)"
            width="200"
            align="center"
          />
          <el-table-column
            prop="dailyAvgChargeElectricity"
            label="日均充电量(kwh)"
            width="200"
            align="center"
          />
           <el-table-column
            prop="weeklyAvgChargeElectricity"
            label="周均充电量(kwh)"
            width="200"
            align="center"
          />
          <el-table-column
            prop="weeklyAvgChargeCount"
            label="周均充电次数"
            width="200"
            align="center"
          />
          <el-table-column
            prop="totalPaidHandlingFee"
            label="累计支付手续费"
            width="200"
            align="center"
          />
          <el-table-column
            prop="totalActualServiceFee"
            label="累计实收服务费"
            width="200"
            align="center"
          />

          <el-table-column
            prop="signTime"
            label="已签约完成时间"
            width="200"
            align="center"
          />

          <el-table-column
            prop="signedUpdateTime"
            label="已签约状态更新时间"
            width="200"
            align="center"
          />

          <el-table-column
            prop="signedWarningStatus"
            label="已签约预警状态"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <block v-if="scope.row.signedWarningStatus != ''">
                <el-tag
                  type="success"
                  v-if="scope.row.signedWarningStatus == '正常'"
                  >{{ scope.row.signedWarningStatus }}</el-tag
                >
                <el-tag
                  type="danger"
                  v-else
                  >{{ scope.row.signedWarningStatus }}</el-tag
                >
              </block>
              <el-tag
                v-else
                type="success"
                >{{ "正常" }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="pileShareConfig"
            label="是否开通私桩共享"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.pileShareConfig === 'Y'">开启</span>
              <span v-if="scope.row.pileShareConfig === 'N'">不开启</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="havePileShareConfig"
            label="是否开通过私桩共享"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.havePileShareConfig === 'Y'">开启</span>
              <span v-if="scope.row.havePileShareConfig === 'N'">不开启</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="mobile"
              label="邀请人"
              width="160"
              align="center"
          >
            <div slot="header" style=" display: flex; align-items: center;justify-content: center;">
              <span style="margin-right: 8px">邀请人</span>
              <img
                  style="width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_隐藏.png"
                  alt=""
                  v-if="!isShareUserFlag"
                  @click="flagChange('2')"
              />
              <img
                  style="width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_显示.png"
                  alt=""
                  v-if="isShareUserFlag"
                  @click="flagChange('2')"
              />
            </div>
            <template slot-scope="scope">
              <span v-if="isShareUserFlag">{{ scope.row.shareUserMobile }}</span>
              <span v-else>{{
                  scope.row.shareUserMobile
                      ? scope.row.shareUserMobile.replace(
                          scope.row.shareUserMobile.substring(2, 9),
                          "*******"
                      )
                      : ""
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="haveCoupon" label="是否获得过折扣券" width="200" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.haveCoupon === 'Y'">是</span>
              <span v-if="scope.row.haveCoupon === 'N'">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="couponCount" label="累计获取折扣券数量" width="200" align="center" />
          <el-table-column prop="couponRedeemCount" label="累计消耗折扣券数量" width="200" align="center" />

          <el-table-column
            prop="parkSpace"
            label="是否有固定车位"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.activityOrder.parkSpace === 'Y'">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="networkEnvironment"
            label="是否可提供联网环境"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.activityOrder.networkEnvironment === 'Y'"
                >是</span
              >
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="province"
            label="省"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.province
            }}</template>
          </el-table-column>
          <el-table-column
            prop="city"
            label="市"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.city
            }}</template>
          </el-table-column>
          <el-table-column
            prop="area"
            label="区"
            width="200"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.activityOrder.area
            }}</template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="详细地址"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.activityOrder.address }}
              <!--
              <el-popover placement="top-start" width="200" trigger="hover" :disabled="scope.row.address.length <= 10">
                <div>{{ scope.row.activityOrder.address }}</div>
                <span slot="reference" v-if="scope.row.activityOrder.address && scope.row.activityOrder.address.length <= 10">{{scope.row.activityOrder.address}}</span>
                <span slot="reference" v-if="scope.row.activityOrder.address && scope.row.activityOrder.address.length > 10">{{scope.row.activityOrder.address.substr(0, 10) + "..."}}</span>
              </el-popover>
              -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        />
      </div>
    </div>

    <!-- 单用户验证开关 -->
    <el-dialog
      title="单用户验证开关"
      width="520px"
      :visible.sync="showSignUserValidDialog"
    >
      <el-form
        :model="userValidFormInfo"
        ref="userValidForm"
        :rules="userValidFormRules"
      >
        <div class="notice-main-title-div">同一个手机号仅申请一次</div>
        <div class="notice-radio-div">
          <el-radio-group v-model="setOnOffFlag">
            <el-radio label="Y">开启</el-radio>
            <el-radio label="N">关闭</el-radio>
          </el-radio-group>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="submitUserValidForm('userValidForm')"
          size="small"
          >提 交</el-button
        >
        <el-button
          @click="showSignUserValidDialog = false"
          size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <!-- 服务费编辑弹框 -->
    <el-dialog
      title="服务费状态设置"
      :visible.sync="dialogServiceFeeVisible"
      width="35%"
    >
      <div style="display: flex; flex-direction: column">
        <el-form
          :model="popFormInfos"
          :rules="popFromRuless"
          ref="ruleForms"
          label-width="130px"
          class="demo-ruleForm"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item
                label="服务费状态:"
                style="width: 100%"
              >
                <el-switch
                  v-model="serviceFreeFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="服务费价格设置:"
                style="width: 100%"
                prop="servicePrice"
              >
                <div style="display: flex">
                  <div>
                    <el-input-number
                      v-model="popFormInfos.servicePrice"
                      size="small"
                      :min="0"
                    />
                  </div>
                  <div>元/度电</div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="设置有效期:"
                style="width: 100%"
              >
                <el-col :span="11">
                  <el-form-item prop="activationStartDatetime">
                    <el-date-picker
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="popFormInfos.activationStartDatetime"
                      type="datetime"
                      placeholder="选择开始时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col
                  class="line"
                  :span="2"
                  >-</el-col
                >
                <el-col :span="11">
                  <el-form-item prop="activationEndDatetime">
                    <el-date-picker
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="popFormInfos.activationEndDatetime"
                      type="datetime"
                      placeholder="选择结束时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="24">有效期结束后将自动恢复默认状态</el-col>
          </el-row>
        </el-form>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogServiceFeeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="makeSures('ruleForms')"
          >确定保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import Area from "../../../components/area-select/index.vue";
export default {
  components: {
    Area,
  },
  data() {
    return {
      orderStatus: [],
      isFlag: false,
      isShareUserFlag: false,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuery: false,
      showSignUserValidDialog: false,
      userValidFormInfo: {},
      userValidFormRules: {},
      onOffFlag: "",
      setOnOffFlag: "",
      onOffFlagName: "",
      orderStatusList: [
        { code: "COMMIT", title: "已报名" },
        { code: "TO_SIGN", title: "待签约" },
        { code: "IN_SIGN", title: "已签约" },
        { code: "TO_INSTALL", title: "待安装" },
        { code: "TO_ACTIVATION", title: "待激活" },
        { code: "IN_USE", title: "使用中" },
        { code: "SWAPPING", title: "换桩中" },
        { code: "TO_COMPLIANCE", title: "待守约" },
        { code: "IN_OVERDUE", title: "已逾期" },
        { code: "IN_DEFAULTED", title: "已违约" },
        { code: "IN_CANCELING", title: "解约申请中" },
        { code: "IN_CANCELLED_BUYOUT", title: "已解约(买断)" },
        { code: "IN_CANCELLED_REFUNDED", title: "已解约(退出)" },
        { code: "IN_CANCELLED_DEFAULTED", title: "已解约(违约)" },
        { code: "IN_CLOSE", title: "已退出" },
        { code: "TO_RESET_SIGN", title: "待激活签约" },
        { code: "IN_EXPIRED", title: "已到期" },
      ],
      activeStatusList: [
        // 01已激活，02激活中，03已失效，04激活异常
        { code: "01", title: "已激活" },
        { code: "03", title: "已失效（解约、到期）" },
        { code: "05", title: "暂停使用（违约、逾期）" },
      ],
      dialogServiceFeeVisible: false,
      popFormInfos: {},
      serviceFreeFlag: false,
      popFromRuless: {
        priceActiveStatus: [
          { required: true, message: "请选择服务费状态", trigger: "change" },
        ],
        servicePrice: [
          { required: true, message: "请选择服务费价格", trigger: "change" },
        ],
        activationStartDatetime: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        activationEndDatetime: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    setServiceFree() {
      let that = this;
      if (this.checkSelectOne(this.selections)) {
        console.log(this.selections[0]);
        that.popFormInfos = JSON.parse(
          JSON.stringify(that.selections[0].activityOrderCustomPrice || {})
        );
        if (that.popFormInfos.priceActiveStatus == "ACTIVE") {
          that.serviceFreeFlag = true;
        } else {
          that.serviceFreeFlag = false;
        }
        that.dialogServiceFeeVisible = true;
      }
    },
    makeSures(formName) {
      let _ = this;
      if (
        this.popFormInfos.activationStartDatetime &&
        this.popFormInfos.activationEndDatetime
      ) {
        console.log(11111);
        const start = new Date(this.popFormInfos.activationStartDatetime);
        const end = new Date(this.popFormInfos.activationEndDatetime);
        if (end <= start) {
          this.$U.error("结束时间必须大于开始时间");
          return;
        }
      }
      _.$refs[formName].validate((valid) => {
        if (valid) {
          _.popFormInfos.priceActiveStatus = _.serviceFreeFlag
            ? "ACTIVE"
            : "INACTIVE";
          _.popFormInfos.activityOrderNo = _.selections[0].activityOrderNo;
          _.$H.post(_, _.$A.zeropay.serviceFree, _.popFormInfos).then((res) => {
            _.dialogServiceFeeVisible = false;
            _.$U.success("服务费设置成功");
            _.init();
          });
        }
      });
    },
    orderStatusChange(val) {
      console.log(val);
      this.queryInfo.statusList = val;
    },
    flagChange(type) {
      let _ = this;
      if (type === '1') _.isFlag = !_.isFlag;
      if (type === '2') _.isShareUserFlag = !_.isShareUserFlag;
    },
    //获取数据
    init() {
      this.getListData(this.pagination, true);
      // this.getMobileValidStatus();
    },
    // 查询用户验证状态
    getMobileValidStatus() {
      let _ = this;
      _.$H.post(_, _.$A.activityOrder.checkMobileQuery, {}).then((res) => {
        this.onOffFlag = res.data.data.onOff || "N";
        this.setOnOffFlag = res.data.data.onOff || "N";
        this.onOffFlagName = "Y" === this.onOffFlag ? "开启" : "关闭";
      });
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.zeropay.list, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    // 活动订单编辑
    toEditOrder() {
      if (this.checkSelectOne(this.selections)) {
        const editInfo = this.selections[0];
        this.$router.push({
          name: "activityOrderZreoListDetail",
          query: {
            id: editInfo.id,
            activityOrderNo: editInfo.activityOrderNo,
          },
        });
      }
    },
    goDetailByOne(row) {
      const editInfo = row;
      const { href } = this.$router.resolve({
        name: "activityOrderZreoListDetail",
        query: {
          id: editInfo.id,
          activityOrderNo: editInfo.activityOrderNo,
        },
      });
      window.open(href, "_blank");
      return;
      this.$router.push({
        name: "activityOrderZreoListDetail",
        query: {
          id: editInfo.id,
          activityOrderNo: editInfo.activityOrderNo,
        },
      });
    },
    goDetailByOnes(row) {
      const editInfo = row;
      const { href } = this.$router.resolve({
        name: "packageZreoListDetail",
        query: {
          edit: 1,
          serviceActivityId: editInfo.zeroPayConfigurationId,
        },
      });
      window.open(href, "_blank");
      return;
      this.$router.push({
        name: "packageZreoListDetail",
        query: {
          edit: 1,
          serviceActivityId: row.zeroPayConfigurationId,
        },
      });
    },
    // 用户验证
    toShowUserValidFun() {
      this.showSignUserValidDialog = true;
    },
    // 提交
    submitUserValidForm() {
      let _ = this;
      _.$H
        .post(_, _.$A.activityOrder.setOnOff, { onOff: this.setOnOffFlag })
        .then(() => {
          _.showSignUserValidDialog = false;
          _.getMobileValidStatus();
          _.$U.success("保存成功");
          _.$U.hideLoading(_);
        });
    },
    // 桩激活切换
    toUpdatePileStatusFun() {
      let _ = this;
      if (this.checkSelectOne(this.selections)) {
        const editInfo = this.selections[0];
        const submitInfo = {
          activateStatusBef: editInfo.activityOrder.activateStatus,
          pileCode: editInfo.activityOrder.pileCode,
          corpNo: editInfo.corpNo,
          activityOrderNo: editInfo.activityActivateRecord.activityOrderNo,
        };
        _.$H
          .post(_, _.$A.activityOrder.activateExchange, submitInfo)
          .then(() => {
            _.$U.hideLoading(_);
            _.$U.success("提交成功！");
            _.getListData(_.pagination, true);
          });
      }
    },
    // 导出
    toExportList() {
      let _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.zeropay.exportList, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        // var downUrl = "http://192.168.8.174:7997" + res.data.data.filePath;
        var downUrl = urls + res.data.data.filePath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    resetQuery() {
      this.queryInfo = {
        searchKey: undefined,
        statusList: undefined,
        refundResult: undefined,
        activateStatus: undefined,
        createFromTime: undefined,
        createToTime: undefined,
        periodFromTime: undefined,
        periodToTime: undefined,
        expireFromTime: undefined,
        expireToTime: undefined,
        province: undefined,
        city: undefined,
        area: undefined,
        channel: undefined,
        installFailReasonList: undefined,
        activityOrderContractStatusList: undefined,
        activityOrderInstallStatusList: undefined,
        signFlag: undefined,
        holdSignStatus: undefined,
        zmSignStatus: undefined,
        signFromTime: undefined,
        signToTime: undefined,
        signedUpdateFromTime: undefined,
        signedUpdateToTime: undefined,
        signedWarningStatusList: undefined,
        networkEnvironment: undefined,
        parkSpace: undefined,
      };
      this.orderStatus = [];

      this.getListData(this.pagination, true);
    },
  },
};
</script>

<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}
.lang-width {
  width: 450px !important;
}
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.notice-main-title-div {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}
.eye {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 20%;
  }
}
</style>
